export default "__VITE_ASSET__05445c89__"